import axios from "../../api/axios";

export const AUTOMATED_EMAIL_ENDPOINTS = {
  SETTINGS: "/v2/automated-emails/settings",
  TEST: "/v2/automated-emails/test",
  INCIDENT_RECIPIENT_OPTIONS: "/v2/automated-emails/incident-recipients/options",
};

/**
 * Turn an axios failure into an Error carrying the server's message.
 */
const toApiError = (error, fallback) => {
  const message = error?.response?.data?.message || error?.message || fallback;
  return new Error(message);
};

/**
 * GET the company's automated email settings.
 * Resolves to { success, data: Settings, preview: { inspectionLadder } }.
 */
export const getAutomatedEmailSettings = async () => {
  try {
    const response = await axios.get(AUTOMATED_EMAIL_ENDPOINTS.SETTINGS);
    return response.data;
  } catch (error) {
    throw toApiError(error, "Failed to load automated email settings");
  }
};

/**
 * PUT settings (partial objects are accepted by the server).
 * Resolves to the same shape as GET.
 */
export const saveAutomatedEmailSettings = async (settings) => {
  try {
    const response = await axios.put(AUTOMATED_EMAIL_ENDPOINTS.SETTINGS, settings);
    return response.data;
  } catch (error) {
    throw toApiError(error, "Failed to save automated email settings");
  }
};

/**
 * POST a sample email to the signed-in user.
 * kind: 'inspection_reminder' | 'inspection_weekly' | 'inspection_monthly'
 * tier (inspection_reminder only): 'heads_up' | 'reminder' | 'action' | 'urgent' | 'due_today' | 'overdue'
 * Resolves to { success, message }.
 */
export const sendAutomatedEmailTest = async ({ kind, tier } = {}) => {
  try {
    const body = tier ? { kind, tier } : { kind };
    const response = await axios.post(AUTOMATED_EMAIL_ENDPOINTS.TEST, body);
    return response.data;
  } catch (error) {
    throw toApiError(error, "Failed to send the sample email");
  }
};

/**
 * GET what the Incident Reports card can choose from (company login only).
 * Resolves to { success, data: { company: { name, email }, managers: [{ _id, name, email, status }] } }.
 */
export const getIncidentRecipientOptions = async () => {
  try {
    const response = await axios.get(AUTOMATED_EMAIL_ENDPOINTS.INCIDENT_RECIPIENT_OPTIONS);
    return response.data;
  } catch (error) {
    throw toApiError(error, "Failed to load the managers");
  }
};
